module.exports = __webpack_public_path__ + "static/media/ulolunselect.60a59a36.png";